export default function Footer() {
  return (
    <div className="row footer">
      <div className="custom-container text-center">
        <p className="legal-text">
          <strong>Aviso Legal:</strong> Os números gerados por este sistema são
          baseados em algoritmos de análise de dados e inteligência artificial,
          sem qualquer garantia de ganho. A loteria é um jogo de azar, e os
          resultados são completamente aleatórios. Este serviço não se
          responsabiliza por quaisquer perdas financeiras ou expectativas não
          atendidas. Jogue com responsabilidade.
        </p>
      </div>
    </div>
  );
}
